import {ReconciliationReport} from '../types';

// What a person calls a run: its channel and the day it reconciled. The composite id is
// in the profile, with a copy button.
export const reportTitle = (report: Pick<ReconciliationReport, 'channel' | 'runDate'>) =>
    `${report.channel} · ${report.runDate}`;
